import { postRequest } from '../../../shared/utils';

export async function getScreenGridIdDetails(screenGridId, configSchema, screenGridIdWhere) {
  const body = {
    columns: ['id', 'mbd_data_grid{data_grid_internal_name}'],
    screenGridId,
    schema: configSchema,
    filterModel: screenGridIdWhere,
    table: 'mbd_screen_to_data_grids',
  };

  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    return { errors };
  }
  return data;
}
